<template>
  <div class="w100">
    <div class="w100 flexVC" v-if="$store.state.isPc" style="padding-top: 80px;">
      <div class="title">学院讲者</div>
      <div class="item ">
        <div class="item-container flexHBC">
          <el-image
            class="item-img "
            :src="wangxiaoAvatar"
            :fit="cover"></el-image>
          <div class="content">
            <div class="item-nickname">王潇</div>
            <div class="item-title">趁早创始人、前《时尚COSMO》出版总编辑、ShapeGirl马甲线大赛发起人、畅销书作家</div>
            <div class="item-introduce">本科毕业于中国传媒大学播音系，2001年在中央电视台1套节目直播整点新闻。后就职于美国安可顾问公司战略传播部。
            </div>
            <div class="item-introduce marT40">2004年考入中国人民大学新媒体专业研究生</div>
            <div class="item-introduce">2006年成立Motionpost设计顾问公司并担任CEO</div>
            <div class="item-introduce">2013年，创建正向生活品牌“趁早” ，秉承“时间看得见”的企业理念，10年间，趁早星球发展成为百万独立女性的精神家园
            </div>
            <div class=" flexHBC" style="margin-top: 125px;">

              <div>
                <el-image
                  @click="navChild"
                  v-for="item in wangxiaoTag"
                  class="item-tag-img marR15"
                  :src="item"
                  :fit="cover"></el-image>
              </div>

              <div class="btn-more-box" @mouseenter="moreEnter" @mouseleave="moreLeave"
                   @click="navChild">
                <div class="btn-more flexHC2" :class="isHover ? 'btn-more-hover' : ''">
                </div>
                <div class="btn-more-text flexHC2" :class="isHover ? 'CFFF' : 'C000'">
                  <span>了解更多</span>
                  <img :src="isHover ? whiteArrow : arrow"
                       style="width: 15px;height: 11px;margin-left: 5px;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="item2 flexHC">
        <div class="item-container flexHBC">
          <el-image
            class="item-img "
            :src="sunxizheAvatar"
            :fit="cover"></el-image>
          <div class="content">
            <div class="item-nickname">孙喜哲</div>
            <div class="item-title">耐克（中国）签约培训师；NIKE NTC Master Trainer；奥力来运动健身学院签约培训</div>
            <div class="item-introduce">BOSU平衡半球国际认证导师</div>
            <div class="item-introduce">SURGE水阻能量管理课程国际培训导师</div>
            <div class="item-introduce">STAIR MASTER HIIT间歇训练课程国际培训导师；TRX（STC）悬吊训练带国际认证导师</div>
            <div class="item-introduce marT40">
              孙喜哲教练希望把一些有价值的内容传递下去，让更多人影响更多人。让参与运动的人获得正确的指导，并且能够享受运动
            </div>
            <div class="item-bottom flexHBC">

              <div>
                <el-image
                  @click="navChild"
                  v-for="item in sunxizheTag"
                  class="item-tag-img marR15"
                  :src="item"
                  :fit="cover"></el-image>
              </div>

              <div class="btn-more-box" @mouseenter="moreEnter" @mouseleave="moreLeave"
                   @click="navChild">
                <div class="btn-more flexHC2" :class="isHover ? 'btn-more-hover' : ''">
                </div>
                <div class="btn-more-text flexHC2" :class="isHover ? 'CFFF' : 'C000'">
                  <span>了解更多</span>
                  <img :src="isHover ? whiteArrow : arrow"
                       style="width: 15px;height: 11px;margin-left: 5px;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="item ">
        <div class="item-container flexHBC">
          <el-image
            class="item-img "
            :src="mucongAvatar"
            :fit="cover"></el-image>
          <div class="content">
            <div class="item-nickname">牟丛</div>
            <div class="item-title">国家级运动健将，知名全国健身小姐、形体小姐、体育模特；是中国第一个阿诺德赛的女子冠军，第一个阿诺德赛的全场冠军</div>
            <div class="item-introduce">中国女子运动员第一次取得IFBB（国际健美联合会职业卡资格）</div>
            <div class="item-introduce">
              牟丛，出生于1985年1月8日，国家级运动健将，是知名的全国健身小姐、形体小姐、体育模特，是中国第一个阿诺德赛的女子冠军、第一个全场冠军，同时也是中国女子运动员第一次取得IFBB（国际健美联合会）职业卡资格
            </div>
            <div class="item-bottom flexHBC">

              <div>
                <el-image
                  @click="navChild"
                  v-for="item in mucongTag"
                  class="item-tag-img marR15"
                  :src="item"
                  :fit="cover"></el-image>
              </div>

              <div class="btn-more-box" @mouseenter="moreEnter" @mouseleave="moreLeave"
                   @click="navChild">
                <div class="btn-more flexHC2" :class="isHover ? 'btn-more-hover' : ''">
                </div>
                <div class="btn-more-text flexHC2" :class="isHover ? 'CFFF' : 'C000'">
                  <span>了解更多</span>
                  <img :src="isHover ? whiteArrow : arrow"
                       style="width: 15px;height: 11px;margin-left: 5px;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="item2 ">
        <div class="item-container flexHBC">
          <el-image
            class="item-img "
            :src="liuchangAvatar"
            :fit="cover"></el-image>
          <div class="content">
            <div class="item-nickname">刘畅</div>
            <div class="item-title">画房子学院创始人；美国麻神理工学院（MIT）建筑系硕士</div>
            <div class="item-introduce">在校期间，曾参与多个科研项目，包括厄瓜多尔首都基多城市设计课题、城市规划，互动体验等</div>
            <div class="item-introduce marT40">MIT毕业设计作品“好奇图书馆”在国内外多个顶尖设计媒体发布</div>
            <div class="item-introduce">2015年参与设计“奥巴马总统图书馆”项目</div>
            <div class="item-introduce">2018年创办画房子学院</div>
            <div class="item-introduce">将艺术与科学融合 引导学生多元化发展，学员作品多次获得国际绘画比赛大奖</div>
            <div class="item-bottom flexHBC">

              <div>
                <el-image
                  @click="navChild"
                  v-for="item in liuchangTag"
                  class="item-tag-img marR15"
                  :src="item"
                  :fit="cover"></el-image>
              </div>

              <div class="btn-more-box" @mouseenter="moreEnter" @mouseleave="moreLeave"
                   @click="navChild">
                <div class="btn-more flexHC2" :class="isHover ? 'btn-more-hover' : ''">
                </div>
                <div class="btn-more-text flexHC2" :class="isHover ? 'CFFF' : 'C000'">
                  <span>了解更多</span>
                  <img :src="isHover ? whiteArrow : arrow"
                       style="width: 15px;height: 11px;margin-left: 5px;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  移动端  -->
    <div class="w100m flexVC Bf0f2f5" v-if="!$store.state.isPc" style="padding-top: 80px;">
      <div class="title-m" style="margin-bottom: 0.48rem;">学院讲者</div>

      <div class="w100m flexVC">
        <div class="item-container-m flexVC">
          <div style="width: calc(100% - 1.28rem);" class="flexVC">
            <el-image
              class="item-img-m "
              :src="wangxiaoAvatar"
              :fit="cover"></el-image>
          </div>
          <div class="w100m flexVC" style="background: #ebedf0;">
            <div class="content-m">
              <div class="item-nickname-m">王潇</div>
              <div class="item-title-m marT20m">趁早创始人、前《时尚COSMO》出版总编辑、ShapeGirl马甲线大赛发起人、畅销书作家</div>
              <div class="item-introduce-m marT30m">
                本科毕业于中国传媒大学播音系，2001年在中央电视台1套节目直播整点新闻。后就职于美国安可顾问公司战略传播部。
              </div>
              <div class="item-introduce-m marT30m">2004年考入中国人民大学新媒体专业研究生</div>
              <div class="item-introduce-m">2006年成立Motionpost设计顾问公司并担任CEO</div>
              <div class="item-introduce-m">2013年，创建正向生活品牌“趁早”
                ，秉承“时间看得见”的企业理念，10年间，趁早星球发展成为百万独立女性的精神家园
              </div>
              <div class="item-bottom-m flexHBC">

                <div class="flexHC">
                  <el-image
                    @click="navChild"
                    v-for="item in wangxiaoTag"
                    class="item-tag-img-m marR15"
                    :src="item"
                    :fit="cover"></el-image>
                </div>

                <div class="btn-more-box-m flexHC2"
                     @click="navChild">
                  <span>了解更多</span>
                  <img :src="isHover ? whiteArrow : arrow"
                       style="width: 0.18rem;height: 0.16rem;margin-left: 5px;">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="w100m flexVC">
        <div class="item-container-m flexVC">
          <div style="width: calc(100% - 1.28rem);" class="flexVC">
            <el-image
              class="item-img-m "
              :src="sunxizheAvatar"
              :fit="cover"></el-image>
          </div>
          <div class="w100m flexVC" style="background: #ebedf0;">
            <div class="content-m">
              <div class="item-nickname-m">孙喜哲</div>
              <div class="item-title-m marT20m">耐克（中国）签约培训师；NIKE NTC Master Trainer；奥力来运动健身学院签约培训
              </div>
              <div class="item-introduce-m marT30m">BOSU平衡半球国际认证导师</div>
              <div class="item-introduce-m">SURGE水阻能量管课程国际培训导师</div>
              <div class="item-introduce-m">STAIR MASTER HIIT间歇训练课程国际培训导师；TRX（STC）悬吊训练带国际认证导师</div>
              <div class="item-introduce-m marT30m">
                孙喜哲教练希望把一些有价值的内容传递下去，让更多人影响更多人。让参与运动的人获得正确的指导，并且能够享受运动
              </div>
              <div class="item-bottom-m flexHBC">

                <div class="flexHC">
                  <el-image
                    @click="navChild"
                    v-for="item in sunxizheTag"
                    class="item-tag-img-m marR15"
                    :src="item"
                    :fit="cover"></el-image>
                </div>

                <div class="btn-more-box-m flexHC2"
                     @click="navChild">
                  <span>了解更多</span>
                  <img :src="isHover ? whiteArrow : arrow"
                       style="width: 0.18rem;height: 0.16rem;margin-left: 5px;">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="w100m flexVC">
        <div class="item-container-m flexVC">
          <div style="width: calc(100% - 1.28rem);" class="flexVC">
            <el-image
              class="item-img-m "
              :src="mucongAvatar"
              :fit="cover"></el-image>
          </div>
          <div class="w100m flexVC" style="background: #ebedf0;">
            <div class="content-m">
              <div class="item-nickname-m">牟丛</div>
              <div class="item-title-m marT20m">
                国家级运动健将，知名全国健身小姐、形体小姐、体育模特；是中国第一个阿诺德赛的女子冠军，第一个阿诺德赛的全场冠军
              </div>
              <div class="item-introduce-m marT30m">中国女子运动员第一次取得IFBB（国际健美联合会职业卡资格）</div>
              <div class="item-introduce-m">
                牟丛，出生于1985年1月8日，国家级运动健将，是知名的全国健身小姐、形体小姐、体育模特，是中国第一个阿诺德赛的女子冠军、第一个全场冠军，同时也是中国女子运动员第一次取得IFBB（国际健美联合会）职业卡资格
              </div>
              <div class="item-bottom-m flexHBC">

                <div class="flexHC">
                  <el-image
                    @click="navChild"
                    v-for="item in mucongTag"
                    class="item-tag-img-m marR15"
                    :src="item"
                    :fit="cover"></el-image>
                </div>

                <div class="btn-more-box-m flexHC2"
                     @click="navChild">
                  <span>了解更多</span>
                  <img :src="isHover ? whiteArrow : arrow"
                       style="width: 0.18rem;height: 0.16rem;margin-left: 5px;">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="w100m flexVC">
        <div class="item-container-m flexVC">
          <div style="width: calc(100% - 1.28rem);" class="flexVC">
            <el-image
              class="item-img-m "
              :src="liuchangAvatar"
              :fit="cover"></el-image>
          </div>
          <div class="w100m flexVC" style="background: #ebedf0;">
            <div class="content-m">
              <div class="item-nickname-m">刘畅</div>
              <div class="item-title-m marT20m">画房子学院创始人；美国麻神理工学院（MIT）建筑系硕士</div>
              <div class="item-introduce-m marT30m">在校期间，曾参与多个科研项目，包括厄瓜多尔首都基多城市设计课题、城市规划，互动体验等</div>
              <div class="item-introduce-m marT30m">MIT毕业设计作品“好奇图书馆”在国内外多个顶尖设计媒体发布</div>
              <div class="item-introduce-m">2015年参与设计“奥巴马总统图书馆”项目</div>
              <div class="item-introduce-m">2018年创办画房子学院</div>
              <div class="item-introduce-m">将艺术与科学融合 引导学生多元化发展，学员作品多次获得国际绘画比赛大奖</div>
              <div class="item-bottom-m flexHBC">

                <div class="flexHC">
                  <el-image
                    @click="navChild"
                    v-for="item in liuchangTag"
                    class="item-tag-img-m marR15"
                    :src="item"
                    :fit="cover"></el-image>
                </div>

                <div class="btn-more-box-m flexHC2"
                     @click="navChild">
                  <span>了解更多</span>
                  <img :src="isHover ? whiteArrow : arrow"
                       style="width: 0.18rem;height: 0.16rem;margin-left: 5px;">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!--  *********************************  -->
    <shape-fotter></shape-fotter>
  </div>
</template>

<script>
  import shapeFotter from '@/components/ShapeFooter'
  import whiteArrow from '@/assets/images/icon_home_right_arrow_white.png'
  import arrow from '@/assets/images/icon_home_right_arrow.png'

  export default {
    name: "CollegeSpeaker",
    data() {
      return {
        content: '趁早读书会是由创始人王潇于2014年4月23日世界读书日发起，全球各城市自发申请组建的“趁早”线下交流平台，旨在帮助大家遇见彼此，共同学习与见证，分享提升，做更多有意义的事。',
        isShow: true,
        isHover: false,
        cover: 'cover',
        wangxiaoAvatar: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/%E7%8E%8B%E6%BD%87.png',
        wangxiaoTag: ['https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/%E5%92%8C%E6%BD%87%E6%B4%92%E5%A7%90%E5%86%99%E4%BD%9C100%E5%A4%A9.jpg', 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/%E5%92%8C%E6%BD%87%E6%B4%92%E5%A7%90%E5%A1%91%E8%BA%AB100%E5%A4%A9.jpg', 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/%E5%8D%81%E4%B8%AA%E4%B8%80%E7%94%9F%20%E5%BD%93%E4%BB%A3%E5%A5%B3%E6%80%A7%E5%BF%85%E8%AF%BB%E5%8D%81%E6%9C%AC%E4%BC%A0%E8%AE%B0.jpg'],
        sunxizheAvatar: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/%E5%AD%99%E5%96%9C%E5%93%B2.png',
        sunxizheTag: ['https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/%E6%98%8E%E6%98%9F%E7%A7%81%E6%95%99100%E5%A4%A9.jpg', 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/%E5%92%8C%E6%BD%87%E6%B4%92%E5%A7%90%E5%A1%91%E8%BA%AB100%E5%A4%A9%E8%BF%9B%E9%98%B6%E7%89%88.jpg', 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/%E5%92%8C%E6%BD%87%E6%B4%92%E5%A7%90%E5%A1%91%E8%BA%AB10%E5%A4%A9%E7%A7%81%E6%95%99%E7%89%88.png'],
        mucongAvatar: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/%E7%89%9F%E4%B8%9B.png',
        mucongTag: ["https://v.chenzao.com/15917739659381voqVfD20UMh0JBM.jpg", "https://v.chenzao.com/15917802511461T7xBF2ycXUlffXP.jpg"],
        liuchangAvatar: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/%E5%88%98%E7%95%85%402x.png',
        liuchangTag: ["https://v.chenzao.com/1590549585140poWZMpo9Zt5ou0Qf.jpeg"],
        whiteArrow: whiteArrow,
        arrow: arrow,
      }
    },

    components: {
      shapeFotter,
    },

    mounted() {
      window.scrollTo(0, 0);
    },

    methods: {
      navChild() {
        let path = '/collegeDetail'
        let query = {
          type: 1,
        }
        console.log(path)
        this.$router.push({
          path: path,
          query: query
        })
      },
      moreEnter(e) {
        this.isHover = true
        // console.log('111111111111111111', this.$refs.more.$el)
        // this.$refs.more.$el.style.cssText = '-webkit-animation: fadeIn 0.3s linear 1;animation: fadeIn 0.3s linear 1;animation-fill-mode: forwards;';
        // this.$refs.moreTest.$el.style.cssText = 'color: #fff;'
      },
      moreLeave(e) {
        this.isHover = false
        // console.log('222222222222222222222')
        // this.$refs.more.$el.style.cssText = 'width: 230px;height: 51px;color: #FFFFFF;';
      },
    },
  }
</script>

<style scoped>

  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 80px;
    margin-bottom: 80px;
  }

  .item {
    width: 100%;
    background: rgba(0, 0, 0, 0.02);
  }

  .item2 {
    width: 100%;
    background: #ffffff;
    padding-top: 80px;
    padding-bottom: 80px;
  }

  .item-container {
    width: calc(100% - 7.71vw - 8.06vw);
  }

  .item-img {
    width: 600px;
    height: 600px;
    margin-left: 7.71vw;
  }

  .content {
    width: 600px;
    margin-left: 20px;
  }


  .item-nickname {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 64px;
  }

  .item-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 20px;
    margin-bottom: 15px;
  }

  .item-introduce {
    font-size: 16px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.45);
    line-height: 24px;
  }

  .item-bottom {
    margin-top: 155px;
  }

  .item-tag-img {
    width: 72px;
    height: 72px;
    border-radius: 50%;
  }

  .btn-more {
    width: 230px;
    height: 51px;
    color: #FFFFFF;
    /*overflow: hidden;*/
  }

  .btn-more-box {
    width: 230px;
    height: 51px;
    border: 1px solid #000000;
    color: #000000;
    position: relative;
    cursor: pointer;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
  }


  .btn-more:after {
  }

  .btn-more-hover {
    width: 230px;
    background: #000000;
    border: 1px solid #000000;
    -webkit-animation: fadeIn 0.3s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: fadeIn 0.3s linear 1;
    animation-fill-mode: forwards;
  }

  @-webkit-keyframes fadeIn { /*兼容性写法。spin是关键帧的动画名称*/
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
    }
  }

  @keyframes fadeIn {
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
      border: 1px solid #000000;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
      border: 1px solid #000000;
    }
  }

  /* ************************************* mobile *********************************************** */
  .title-m {
    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }

  .item-img-m {
    width: 3.46rem;
    height: 3.46rem;
  }

  .item-container-m {
    width: 100%;
    padding-top: 0.64rem;
  }

  .content-m {
    width: 6.66rem;
    background: #ebedf0;
  }

  .item-nickname-m {
    font-size: 0.26rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 0.48rem;
  }

  .item-title-m {
    font-size: 0.22rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.45);
  }

  .item-introduce-m {
    font-size: 0.22rem;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.45);
    line-height: 0.36rem;
    text-align: justify;
  }

  .item-bottom-m {
    width: 100%;
    margin-top: 0.64rem;
    padding-bottom: 0.64rem;
  }

  .item-tag-img-m {
    width: 0.82rem;
    height: 0.82rem;
    border-radius: 50%;
  }

  .btn-more-box-m {
    width: 2.02rem;
    height: 0.64rem;
    border-radius: 4px;
    border: 1px solid #000000;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    cursor: pointer;
    z-index: 500;
  }

  .marT40m {
    margin-top: 0.8rem;
  }

  .marT20m {
    margin-top: 0.2rem;
  }

  .marT30m {
    margin-top: 0.4rem;
  }

  marT32m {
    margin-top: 0.64rem;
  }


  /* ************************************************************************************ */

</style>



// WEBPACK FOOTER //
// src/page/college/CollegeSpeaker.vue